<template>
  <div class="w-100">
    <div class="row ">
      <b-pagination
          @change="onChangePage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="meta.per_page"
      ></b-pagination>
      <span style="color: rgb(128,128,128)" class=" m-2">تعداد کل
        {{formatNumber(totalRows)}}</span>
    </div>
  </div>


</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "Pagination",
  methods: {formatNumber},
  props: ['meta', 'onChangePage'],
  data() {
    return {
      currentPage: 1,
    }
  },
  computed: {
    totalRows() {
      return this.meta.total;
    }
  }
}
</script>

<style scoped>

</style>